module.exports = __webpack_public_path__ + "opticutBanner.png?941761c33fd757a922efb01772947585";